import { render, staticRenderFns } from "./ByLeadersTotalItem.vue?vue&type=template&id=3ca59f93&scoped=true&lang=pug&"
import script from "./ByLeadersTotalItem.vue?vue&type=script&lang=js&"
export * from "./ByLeadersTotalItem.vue?vue&type=script&lang=js&"
import style0 from "./ByLeadersTotalItem.vue?vue&type=style&index=0&id=3ca59f93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca59f93",
  null
  
)

export default component.exports